import styled from "styled-components";
import { NavLink } from "react-router-dom";

import breakpoints from "../../../../../theme-style/breakpoints";
import GenericTitleWithToolTip from '../../../../../components/molecules/GenericTitleWithToolTip';

export const MainContainer = styled.div`
`;

export const StyledTitleWithToolTip = styled(GenericTitleWithToolTip)`
  color: white;
  font-size: 16px;
  font-weight: 700;
  padding: 0 0 8px 0;
  @media ${breakpoints.mobileXL} {
    padding: 0 0 15px 0;
  }
`;

export const ServicesWrapper = styled.div`
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 15px;

  @media ${breakpoints.mobileXL} {
    margin-bottom: 20px;
  }
`;

export const ServicesPrestationsTitle = styled.strong`
  font-weight: 600;
  font-size: 14px;
  color: #5A5A5A;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  transition: all .2s ease-out;
`;

export const ArrowIconWrapper = styled.span`
  max-width: 7px;
  max-height: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 0 0 auto;
  svg path{
    transition: all .2s ease-out;
  }
`;

export const ServicesPrestations = styled(NavLink)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  background-color: #FFFFFF;
  text-decoration: none;
  cursor: pointer;
  transition: all .2s ease-out;
  border-bottom: 1px solid #F4F4F4;
  &:hover{
    background-color: #FAFAFA;
    ${ServicesPrestationsTitle}{
      color: #40B176;
    }
    ${ArrowIconWrapper}{
      svg{
        path{
          fill: #40B176;
          stroke: #40B176;
        }
      }
    }
  }
`;

export const ServicesPrestationsTop = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding: 12px 15px;

  @media ${breakpoints.mobileXL} {
    padding: 15px 20px 15px 25px;
  }
`;

export const ServicesPrestationsCircle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  min-width: 30px;
  height: 30px;
  min-height: 30px;
  background-color: #EDEDED;
  border-radius: 100px;
  margin: 0 25px 0 0;
`;

export const ServicesCircle = styled.div`
  width: 5px;
  min-width: 5px;
  height: 5px;
  min-height: 5px;
  background-color: #4A90E2;
  border-radius: 100px;
  margin: 0;
  &:nth-child(2){
    margin: 0 2px;
  }
  &.borneItemCircle-blue{
    background-color: #4A90E2;
  }
  &.borneItemCircle-green{
    background-color: #40B176;
  }
  &.borneItemCircle-orange{
    background-color: #FF9F6D;
  }
`;

export const ServicesPrestationsMiddle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  padding: 0px 25px 15px 25px;
  box-sizing: border-box;
`;

export const ServicesPrestationsMiddleItem = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  padding: 3px 0;
  box-sizing: border-box;
`;

export const ServicesPrestationsMiddleItemText = styled.p`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: 12px;
  line-height: 12px;
  font-weight: 500;
  color: #c7c7c7;
  margin: 0px 10px 0 0;
`;

export const ServicesPrestationsMiddleItemDate = styled.div`
  margin: 0 0 0 auto;
  background-color: #4A90E2;
  color: white;
  font-size: 11px;
  font-weight: 600;
  padding: 4px 7px;
  border-radius: 4px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const ServicesOnlyCircle = styled.div`
  width: 8px;
  min-width: 8px;
  height: 8px;
  min-height: 8px;
  background-color: #4A90E2;
  border-radius: 100px;
  margin: 0 36px 0 11px;
  &.borneItemOnlyCircle-blue{
    background-color: #4A90E2;
  }
  &.borneItemOnlyCircle-green{
    background-color: #40B176;
  }
  &.borneItemOnlyCircle-orange{
    background-color: #FF9F6D;
  }
`;

export const ServicesWithoutPrestations = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  background-color: #FFFFFF;
  border-bottom: 1px solid #F4F4F4;
`;

export const ServicesWithoutPrestationsTop = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  box-sizing: border-box;
  padding: 12px 15px;

  @media ${breakpoints.mobileXL} {
    padding: 15px 20px 15px 25px;
  }
`;

export const ServicesItemContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

export const ServicesItemTitle = styled.strong`
  font-weight: 600;
  font-size: 14px;
  color: #5A5A5A;
  transition: all .2s ease-out;
`;

export const ServicesItemText = styled.p`
  margin: 4px 0 0 0;
  font-size: 12px;
  color: #BBBBBB;
  line-height: 14px;
  font-weight: 600;
`;